export const OPERATIONS_GLOSSARY = [
  {
    key: 'operations.reliability',
    label: 'Confiabilidade por operação',
    whatIs: 'Uma linha por operação com evento no período: quantas vezes foi tentada, quantas deram certo, quantas falharam por regra ou por erro técnico e quanto tempo levou.',
    purpose: 'Mostra se as operações críticas funcionam e onde estão as falhas e a lentidão, para priorizar correção.',
    howGenerated: 'Eventos de uso agregados por hora em horário universal (UTC, sem fuso) e somados nos dias de Brasília do período. Entram todas as empresas, inclusive inativas, menos as internas e as de Portugal.',
    caveat: 'Não há corte por empresa, papel, porte ou perfil. Só 5 operações registram falha; nas demais aparecem só os sucessos.',
    seeAlso: ['operations.successRate'],
  },
  {
    key: 'operations.operation',
    label: 'Operação',
    whatIs: 'Ação do produto acompanhada pelo PI, como geração de espelho, reconhecimento facial na batida ou execução do relatório avançado, com a chave técnica abaixo do nome.',
    purpose: 'Identifica o que está sendo medido; a chave técnica é a mesma usada no catálogo de eventos e nos registros.',
    howGenerated: 'Cada evento do catálogo aponta para uma operação; o nome vem do catálogo de rótulos do PI.',
    seeAlso: ['operations.note'],
  },
  {
    key: 'operations.note',
    label: 'Observação da operação',
    whatIs: 'Explicação curta do que a linha conta, quando a operação tem uma regra própria (por exemplo, a batida conta só as gravadas).',
    purpose: 'Evita ler a linha errado, como achar que uma operação sem falha registrada nunca falha.',
    howGenerated: 'Texto fixo do servidor para a operação.',
  },
  {
    key: 'operations.attempts',
    label: 'Tentativas',
    whatIs: 'Quantas vezes a operação foi tentada; repetir a mesma tentativa (mesma chave) conta uma vez só, e as repetidas aparecem abaixo.',
    purpose: 'É a base da taxa de sucesso e mostra o volume de uso da operação.',
    howGenerated: 'Tentativas distintas por chave de repetição em cada hora, somadas no período. Só nas 5 operações com falha registrada: espelho, facial na batida e três do relatório avançado.',
    caveat: 'A mesma chave em horas diferentes conta duas vezes. Nas outras operações aparece "—" e o motivo no mouse.',
  },
  {
    key: 'operations.success',
    label: 'Sucessos',
    whatIs: 'Quantas tentativas terminaram como deviam. Nas operações sem falha registrada, são as conclusões registradas; no registro de ponto, as batidas gravadas.',
    purpose: 'Mostra o volume do que deu certo e, nas operações sem falha medida, o único número de uso disponível.',
    howGenerated: 'Eventos com resultado de sucesso agregados por hora e somados no período; as batidas vêm das marcações gravadas nos bancos dos clientes, por dia.',
    caveat: 'No facial, sucesso é o rosto reconhecido; isso não garante que a batida foi gravada.',
  },
  {
    key: 'operations.businessFail',
    label: 'Falha funcional',
    whatIs: 'Tentativas recusadas por uma regra de negócio, como sem permissão, período fechado ou registro duplicado. Abaixo, a parte das tentativas; no detalhe, a parte das falhas.',
    purpose: 'Separa recusa esperada pelo sistema de defeito: muita falha funcional pode indicar tela confusa ou configuração errada do cliente.',
    howGenerated: 'Eventos com resultado de falha funcional agregados por hora e somados no período; parte = falhas funcionais ÷ tentativas.',
    seeAlso: ['operations.technicalFail'],
  },
  {
    key: 'operations.technicalFail',
    label: 'Falha técnica',
    whatIs: 'Tentativas que terminaram em erro do sistema: exceção, erro do motor ou falha de infraestrutura. Abaixo, a parte das tentativas; no detalhe, a parte das falhas.',
    purpose: 'É o sinal de defeito ou instabilidade a investigar com o time técnico.',
    howGenerated: 'Eventos com resultado de falha técnica agregados por hora e somados no período; parte = falhas técnicas ÷ tentativas.',
    seeAlso: ['operations.businessFail'],
  },
  {
    key: 'operations.successRate',
    label: 'Taxa de sucesso',
    whatIs: 'Parte das tentativas que deu certo no período, com "sucessos de tentativas" abaixo.',
    purpose: 'Mede a confiabilidade da operação; uma queda pede investigar as categorias de falha no detalhe.',
    howGenerated: 'Sucessos ÷ tentativas distintas × 100. Com menos de 30 tentativas sai "Dados insuficientes"; sem falha registrada, n/d. Período com dia não fechado sai parcial.',
    metricKey: 'success_rate',
    seeAlso: ['operations.attempts', 'operations.successCompare'],
  },
  {
    key: 'operations.successCompare',
    label: 'Taxa de sucesso no período anterior',
    whatIs: 'Taxa de sucesso no período anterior de mesmo tamanho e a diferença para o período atual, em pontos percentuais (p.p.).',
    purpose: 'Mostra se a confiabilidade melhorou ou piorou.',
    howGenerated: 'Mesma regra da taxa, calculada no período anterior; diferença = taxa atual − taxa anterior. Só com "Comparar" ligado.',
  },
  {
    key: 'operations.duration',
    label: 'Duração p50 / p95 / p99',
    whatIs: 'Tempo que a operação levou: p50 é o tempo da tentativa do meio, p95 e p99 são os tempos que 95% e 99% das tentativas não passaram (percentis).',
    purpose: 'Mostra a lentidão percebida pela maioria (p50) e pelos piores casos (p95 e p99).',
    howGenerated: 'Percentis de cada hora combinados pela média ponderada pelo volume; a exportação traz os valores em milissegundos.',
    caveat: 'É uma aproximação, não um percentil exato do período. O dia de hoje entra sem percentil até o fechamento.',
  },
  {
    key: 'operations.trend',
    label: 'Tendência da operação',
    whatIs: 'Minigráfico diário da taxa de sucesso, nas operações com falha registrada, ou do volume de sucessos, nas demais.',
    purpose: 'Separa queda pontual de queda contínua sem abrir o detalhe.',
    howGenerated: 'Um ponto por dia de Brasília do período, com a mesma regra da coluna correspondente.',
    caveat: 'A tendência não vai na exportação; a série diária completa está em "Detalhar".',
  },
  {
    key: 'operations.failureCategory',
    label: 'Categoria de falha',
    whatIs: 'Motivo informado pela operação para a falha, como "Nenhum rosto detectado" no facial ou um código do relatório avançado.',
    purpose: 'Diz por que a operação falha, para atacar a causa mais frequente.',
    howGenerated: 'A cada hora o PI guarda as 3 categorias mais frequentes de cada operação; a tabela soma essas contagens no período. Códigos sem nome conhecido aparecem como vieram.',
    caveat: 'Categorias fora das 3 mais frequentes de cada hora não aparecem.',
  },
  {
    key: 'operations.failureType',
    label: 'Tipo da falha',
    whatIs: 'Se a categoria é falha funcional (a regra recusou) ou técnica (erro do sistema), quando a fonte informa.',
    purpose: 'Separa o que é comportamento esperado do que é defeito.',
    howGenerated: 'Vem do resultado gravado junto com a categoria; quando a fonte não informa, a coluna fica vazia.',
  },
  {
    key: 'operations.failureCount',
    label: 'Ocorrências da categoria',
    whatIs: 'Quantas falhas tiveram a categoria no período e a participação dela entre as categorias listadas.',
    purpose: 'Ordena as causas de falha por peso.',
    howGenerated: 'Soma das contagens horárias da categoria; participação = contagem ÷ soma das categorias listadas.',
    caveat: 'A participação é entre as categorias registradas, não sobre o total de falhas.',
  },
];



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/glossary/operations.js